import React from 'react';

import { ConfirmationIcon } from '#/assets/svgs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, Button } from '#/components/ui';

const DeleteContactsModal = ({ open, onClose, onConfirm, contactCount = 1, deleteContact, isLoading = false }) => {
    const handleClose = () => {
        onClose(false);
    };
    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className='flex flex-col gap-8 p-6 max-w-[25rem] bg-white'>
                <DialogHeader className='flex flex-col gap-5'>
                    <DialogTitle>
                        <ConfirmationIcon className='w-12 h-12' />
                    </DialogTitle>
                    <DialogDescription className='flex flex-col space-y-2'>
                        <span className='text-lg text-gray900 font-medium'>Are You Sure?</span>
                        <span className='text-sm font-normal text-gray500'>
                            You are about to remove{' '}
                            {contactCount === 1 && deleteContact ? (
                                `"${deleteContact}" `
                            ) : (
                                <span className='font-medium text-sm text-gray800'>
                                    {contactCount} {contactCount > 1 ? 'Contacts ' : 'Contact '}
                                </span>
                            )}
                            from the contacts listing. Are you sure you want to proceed?
                        </span>
                    </DialogDescription>
                </DialogHeader>
                <div className='flex justify-between gap-3 w-full'>
                    <Button variant='outline' className='w-1/2 bg-transparent' onClick={handleClose}>
                        Close
                    </Button>
                    <Button className='w-1/2' onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? 'Removing...' : 'Yes, Remove'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteContactsModal };
